export default "__VITE_PUBLIC_ASSET__4514dd84__"